module.exports = __webpack_public_path__ + "static/shuttle-bb05c9b3fce8ddfa23a547f6582b62a3.png";